import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=04fcb04d&scoped=true&"
import script from "./SubMenu.vue?vue&type=script&lang=js&"
export * from "./SubMenu.vue?vue&type=script&lang=js&"
import style0 from "./SubMenu.vue?vue&type=style&index=0&id=04fcb04d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fcb04d",
  null
  
)

export default component.exports